export const blockIconsSearchYard = (
	<span className='material-symbols-outlined'>yard</span>
);
